module.exports = __webpack_public_path__ + "static/08-thumb-a4e43d2e6e131a59ed3cafaf4b567025.jpg";